// extracted by mini-css-extract-plugin
export default {"progressHolder":"ProgressTheme--progressHolder--ZRpn7HTS","dot":"ProgressTheme--dot--YFKg3_RY","current":"ProgressTheme--current--e0KaXAub"};